export const columns = [
  { field: 'id', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header', },
  {
    field: 'firstName',
    headerName: 'First name',
    headerClassName: 'super-app-theme--header',
    width: 150,
    // editable: true,
  },
  {
    field: 'lastName',
    headerName: 'Last name',
    headerClassName: 'super-app-theme--header',
    width: 150,
    // editable: true,
  },
  {
    field: 'age',
    headerName: 'Age',
    headerClassName: 'super-app-theme--header',
    type: 'number',
    width: 110,
    // editable: true,
  },
  {
    field: 'fullName',
    headerName: 'Full name',
    description: 'This column has a value getter and is not sortable.',
    headerClassName: 'super-app-theme--header',
    sortable: false,
    width: 160,
    valueGetter: (params) =>
      `${params.row.firstName || ''} ${params.row.lastName || ''}`,
  },
];

export const columnsDisponibility = [
  { field: 'id', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header', },
  {
    field: 'nombre_sitio',
    headerName: 'Nombre del Sitio',
    headerClassName: 'super-app-theme--header',
    flex: 1,
    // editable: true,
  },
  {
    field: 'id_sitio',
    headerName: 'ID del sitio',
    headerClassName: 'super-app-theme--header',
    flex: 1,
    // editable: true,
  },
  {
    field: 'disponibilidad',
    headerName: 'Disponibilidad',
    headerClassName: 'super-app-theme--header',
    // type: 'number',
    flex: 1,
    // editable: true,
  },
  {
    field: 'full',
    headerName: 'IDC',
    description: 'This column has a value getter and is not sortable.',
    headerClassName: 'super-app-theme--header',
    sortable: false,
    flex: 1,
    valueGetter: (params) =>
      `${params.row.nombre_sitio || ''} ${params.row.id_sitio || ''}`,
  },
];

export const rowsDisponibility = [
  { id: "TCK-001", id_sitio: 'IDS-001', nombre_sitio: 'A', disponibilidad: "30%", full: '' },
  { id: "TCK-002", id_sitio: 'IDS-002', nombre_sitio: 'B', disponibilidad: "40%", full: ''},
  { id: "TCK-003", id_sitio: 'IDS-003', nombre_sitio: 'C', disponibilidad: "50%", full: '' },
  { id: "TCK-004", id_sitio: 'IDS-004', nombre_sitio: 'D', disponibilidad: "78%", full: '' },
  { id: "TCK-005", id_sitio: 'IDS-005', nombre_sitio: 'E', disponibilidad: "90%", full: '' },
  { id: "TCK-006", id_sitio: 'IDS-006', nombre_sitio: 'F', disponibilidad: "100%", full: '' },
];
  
export const rows = [
  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];